module.exports = __webpack_public_path__ + "static/media/BW.8eeadf27.svg";